import FJTextBaseEditAudioRight from '../view/FJTextBaseEditAudioRight';
import { useDispatch, useSelector } from 'react-redux';
import FJActionRightTextBaseEditing from '../../../../redux/action/textBasedEditing/FJActionRightTextBaseEditing.js';

const FJTextBaseEditAudioRightContainer = () => {
    const dispatch = useDispatch();
    const splitTimeList = useSelector(state => state.rightTextBaseEditing.splitTimeList);

    const _onClick = () => {
        dispatch(FJActionRightTextBaseEditing.pauseAction());
    };

    if (splitTimeList.length === 0) {
        return null;
    }
    return <FJTextBaseEditAudioRight onClick={_onClick} />;
};

export default FJTextBaseEditAudioRightContainer;
